/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Lazy loading of the component PageNews
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

import loadable from '@utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageNews" */ './PageNews'), undefined);
